module.exports = __webpack_public_path__ + "img/slide-3.448ed426.webp";